module.exports = __webpack_public_path__ + "img/notification-email.0c87f625.png";